import type {
  PersistedSelectedAppliances,
  SelectedAppliances,
  SelectedSinksAmount,
} from '~/core/types/appliances';

/**
 * Builds the persisted appliance selections written into a saved estimate.
 *
 * Captures the "+ Add"/panel sink selections and the current cooktop/range
 * selections. Only the persisted `selected` maps are kept — the transient
 * `previousSelected` (undo state) is dropped so it is never serialized. Note the
 * `selected` map still carries `onShape`, but that value is authoritative only for
 * the drawing shapes: on restore it is recomputed from the restored shapes (the
 * persisted `onShape` is superseded; only `onCard` is restored as-is).
 */
export const buildApplianceSelectionsForEstimate = ({
  selectedSinks,
  cooktops,
  ranges,
}: {
  selectedSinks: SelectedSinksAmount;
  cooktops: SelectedAppliances;
  ranges: SelectedAppliances;
}): {
  selectedSinks: SelectedSinksAmount;
  selectedCookingAppliances: PersistedSelectedAppliances;
} => ({
  selectedSinks: [...selectedSinks],
  selectedCookingAppliances: {
    selectedCooktopApplianceProduct: { selected: { ...cooktops.selected } },
    selectedRangeApplianceProduct: { selected: { ...ranges.selected } },
  },
});
